module.exports = __webpack_public_path__ + "static/media/gameoflife.66d30150.jpg";